<template>
  <div>
    <v-page-toolbar :title="$t('_menu.issues')" icon="mark_unread_chat_alt">
    </v-page-toolbar>
    <v-layout row wrap fluid>
      <v-flex lg12>
        <issue-table
          :filter.sync="filter"
          :issueItems="filterIssue"
          :issueCategories="issueCategories"
          @placeClick="placeClick"
          @placeReClick="placeReClick"
        />
      </v-flex>
    </v-layout>
    <VMap
      :showPoints="issues"
      showType="issues"
      :mapCenter.sync="center"
      :mapZoom.sync="zoom"
      :showPlaceInfo.sync="showDialog"
      :showPlaceCoord="placeCoord"
      :selectedPlace="selectedItem"
      :selectedAssets="selectedAssets"
      :selectedText="selectedText"
      :selectedTitle="selectedTitle"
    />
  </div>
</template>

<script>
import IssueTable from "./IssueTable";
import { mapActions, mapGetters } from "vuex";
import VMap from "@/components/ui/VMap.vue";

export default {
  components: { IssueTable, VMap },

  async created() {
    // this.filter = JSON.parse(JSON.stringify(this.emptyFilter));
    const jwt = this.$store.getters["auth/jwtDecoded"];
    if (jwt.city_code === "59") {
      this.center = [27.511675, 40.978092];
      this.cityCenter = [27.511675, 40.978092];
    } else {
      this.center = [36.33534518345682, 41.295020754851635];
      this.cityCenter = [36.33534518345682, 41.295020754851635];
    }
    this.getIssueCategories();
  },
  
  data() {
    return {
      routeId: "7166c32d-b6f9-4a97-85c4-0124acb2713b",

      filter: {},
      // emptyFilter: {
      //   name: "",
      //   cityCode: null,
      //   countyCode: null,
      //   categoryIds: [],
      // },
      newItem: {
        title: "",
        text: "",
        date: "",
      },
      dialog: false,
      itemIndex: -1,
      page: 0,
      totalItemsPerPage: 10000,
      places: null,
      center: [],
      cityCenter: [],
      zoom: 9,
      showDialog: false,
      placeCoord: [],
      selectedItem: null,
      selectedAssets: [],
      selectedTitle: "",
      selectedText: "",
    };
  },
  computed: {
    ...mapGetters({ issues: "issues/items" }),
    ...mapGetters({ issueCategories: "issues/issueCategories" }),
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
    filterIssue() {
      return this.issues.map((issue) =>
        Object.assign({}, issue, {
          creationDateTime:
          issue.creationDateTime.toLocaleString(this.lang) || {},
          doneDateTime: issue.doneDateTime
            ? issue.doneDateTime.toLocaleString(this.lang)
            : "",
          categoryName: (
            this.issueCategories.find(
              (category) => category.id === issue.issueCategoryId
            ) || {}
          ).name,
        })
      );
    },
  },
  methods: {
    ...mapActions(["issues/getItems"]),
    ...mapActions(["issues/getIssueCategories"]),

    async getIssueCategories() {
      await this.$store.dispatch("issues/getIssueCategories");
    },
    async refreshTable() {
      console.log("after confirm");
      let filterr = JSON.parse(JSON.stringify(this.filter));

      //filterr.categoryIds.push(this.routeId);
      await this.$store.dispatch("issues/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        filter: filterr,
      });
    },
    onConfirmed(editedItem) {
      // hide a dialog
      console.log("confffffffffffffirmeddddd");
      this.dialog = false;
      this.refreshTable();
      // save a user and refresh a table
    },
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
    placeClick(item) {
      console.log("placetable", item);
      console.log("son adım");
      this.center = [item.lon, item.lat];
      this.placeCoord = [item.lon, item.lat];
      this.zoom = 16;
      this.showDialog = true;
      this.selectedItem = item;
      this.selectedAssets = item.issueAssets;
      this.selectedTitle = item.categoryName;
      this.selectedText = item.issueDescription;
    },
    placeReClick() {
      this.center = this.cityCenter;
      this.zoom = 9;
      this.showDialog = false;
      this.selectedItem = null;
    },
  },
};
</script>